import { FC, useState } from "react";
import TableMaterial from "../../../components/tableMaterial/tableMaterial";
import UseGetWithdrawals from "../../../service/userCreateWithDrawls/getWithDrawals";
import { TableCustomProps } from "../../../components/table/table";
import { Amount } from "../../tranference/withdrawals/drawls/tableDrawls/amount/Amount";
import StatusLabel from "../../../components/utils/StatusLabel";
import { formatToMexicoDateTime } from "../../../components/utils/format";
import { Button } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { WithdrawInfoModal } from "./WithdrawInfoModal"; 

export const WithdrawalsHistoryTable: FC<any> = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const { transaction, loading } = UseGetWithdrawals(page, rowsPerPage);

  const [selectedWithdraw, setSelectedWithdraw] = useState<any>(null);
  const [openModal, setOpenModal] = useState(false);

  const handleOpenModal = (withdraw: any) => {
    setSelectedWithdraw(withdraw);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedWithdraw(null);
  };

  const transformDataToTable = (withdrawals: any): TableCustomProps["rows"] => {
    return withdrawals?.map((item: any) => ({
      id: item?._id,
      amount: <Amount value={item?.amount} />,
      status: <StatusLabel value={item?.status} />,
      created_at: formatToMexicoDateTime(item?.created_at),
      info: (
        <Button
          variant="outlined"
          size="small"
          onClick={() => handleOpenModal(item)}
          startIcon={<InfoIcon />}
        >
          Info
        </Button>
      ),
    }));
  };

  const dataTable: any = {
    columns: [
      { id: "id", label: "ID de retiro" },
      { id: "amount", label: "Cantidad de retiro" },
      { id: "status", label: "Estatus" },
      { id: "created_at", label: "Fecha de solicitud" },
      { id: "info", label: "Información" }, 
    ],
    rows: transformDataToTable(transaction?.data ? transaction?.data : []),
  };

  return (
    <div>
      <TableMaterial
        id="withdrawals-history-table"
        report={true}
        isSearch={false}
        loading={loading}
        columns={dataTable.columns}
        rows={dataTable.rows}
        totalRows={transaction?.total}
        setPage={setPage}
        page={page}
        isDate={false}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
      />

      <WithdrawInfoModal
        open={openModal}
        onClose={handleCloseModal}
        data={selectedWithdraw}
      />
    </div>
  );
};